import { ErrorResponse, Uuid } from 'ValueObjects';
import axios, { AxiosError, AxiosResponse } from 'axios';
import {
  useMutation,
  UseMutationResult,
  UseMutationOptions,
} from '@tanstack/react-query';
import { User } from 'Models';

export type UpdateUserProfilePictureMutationProps = {
  userId: Uuid;
  profilePictureId?: Uuid | null;
};

export const UpdateUserProfilePictureMutation = async ({
  ...values
}: UpdateUserProfilePictureMutationProps): Promise<AxiosResponse<User>> =>
  axios.put(`api/users/${values.userId}/update-profile-picture`, {
    ...values,
  });

export const useUpdateUserProfilePictureMutation = (
  options: UseMutationOptions<
    AxiosResponse<User>,
    AxiosError<ErrorResponse>,
    UpdateUserProfilePictureMutationProps
  > = {}
): UseMutationResult<
  AxiosResponse<User>,
  AxiosError<ErrorResponse>,
  UpdateUserProfilePictureMutationProps
> =>
  useMutation<
    AxiosResponse<User>,
    AxiosError<ErrorResponse>,
    UpdateUserProfilePictureMutationProps
  >(UpdateUserProfilePictureMutation, {
    useErrorBoundary: false,
    ...options,
  });
